export const triggerAudienceTag = (values) => {
    // House owner segment
    // This script is triggered when an estimation is created for a house owner
    if (values._property_type === 'house' && values.profile_owner === true) {
        var a = String(Math.floor(Math.random() * 10000000000000000));
        new Image().src =
            'https://pubads.g.doubleclick.net/activity;dc_iu=/199043128/DFPAudiencePixel;ord=' +
            a +
            ';dc_seg=7822003057?';
    }
};
